module.exports = __webpack_public_path__ + "img/7.5f24dada.jpg";